import cx from "classnames";

import { type ProgressBarSize, type ProgressBarVariant } from "./types";

export const SIZE_CLASSNAME: Record<ProgressBarSize, string> = {
	xs: "h-1",
	sm: "h-2",
} as const;

export const VARIANT_CLASSNAME: Record<ProgressBarVariant, string> = {
	brand: "bg-brand",
	positive: "bg-positive",
	warning: "bg-warning",
	negative: "bg-negative",
	graduated: "", // placeholder, depends on value
} as const;

export const THUMB_SIZE_CLASSNAME: Record<ProgressBarSize, string> = {
	xs: "w-2 h-2",
	sm: "w-4 h-4",
} as const;

export const THUMB_VARIANT_CLASSNAME: Record<ProgressBarVariant, string> = {
	brand: cx(
		"ring-normal",
		"bg-button-normal-primary-default",
		"hover:bg-button-normal-primary-hover",
		"focus:bg-button-normal-primary-focus",
		"active:bg-button-normal-primary-active",
		"shadow-border-normal-default-raised",
		"hover:shadow-border-normal-hover-raised",
		"focus:shadow-border-normal-focus",
		"active:shadow-border-normal-active"
	),
	positive: cx(
		"ring-positive",
		"bg-button-positive-primary-default",
		"hover:bg-button-positive-primary-hover",
		"focus:bg-button-positive-primary-focus",
		"active:bg-button-positive-primary-active",
		"shadow-border-positive-default-raised",
		"hover:shadow-border-positive-hover-raised",
		"focus:shadow-border-positive-focus",
		"active:shadow-border-positive-active"
	),
	negative: cx(
		"ring-negative",
		"bg-button-negative-primary-default",
		"hover:bg-button-negative-primary-hover",
		"focus:bg-button-negative-primary-focus",
		"active:bg-button-negative-primary-active",
		"shadow-border-negative-default-raised",
		"hover:shadow-border-negative-hover-raised",
		"focus:shadow-border-negative-focus",
		"active:shadow-border-negative-active"
	),
	warning: cx(
		"ring-warning",
		"bg-button-warning-primary-default",
		"hover:bg-button-warning-primary-hover",
		"focus:bg-button-warning-primary-focus",
		"active:bg-button-warning-primary-active",
		"shadow-border-warning-default-raised",
		"hover:shadow-border-warning-hover-raised",
		"focus:shadow-border-warning-focus",
		"active:shadow-border-warning-active"
	),
	graduated: "", // placeholder, depends on value
} as const;

export const VALUE_LABEL_SIZE_CLASSNAME: Record<ProgressBarSize, string> = {
	xs: "text-xxs",
	sm: "text-xs",
} as const;

export const VALUE_LABEL_VARIANT_CLASSNAME: Record<ProgressBarVariant, string> = {
	brand: "text-primary",
	positive: "text-positive",
	warning: "text-warning",
	negative: "text-negative",
	graduated: "", // placeholder, depends on value
} as const;
